import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class GetdataService {
  authToken: any;
  user: any;
  baseURL: String;

  constructor(private authService: AuthService, private http: HttpClient) {
    this.baseURL = this.authService.baseURL;
  }

  loadToken() {
    const token = localStorage.getItem('bUser_token');
    this.authToken = token;
    const user = localStorage.getItem('user');
    this.user = user;
  }
  gettableData() {
    this.loadToken();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', this.authToken);
    return this.http.get(this.baseURL + 'data/datatable', { headers: headers });
  }
  
  cancelReg(body){
    this.loadToken();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', this.authToken);
    return this.http.post(this.baseURL + 'data/cancelRegis', body,{ headers: headers });
  }

  getAPData(){
    this.loadToken();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', this.authToken);
    return this.http.get(this.baseURL + 'data/a_p', { headers: headers });
  }

  sendConfirmation(obj){
    this.loadToken();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', this.authToken);
    return this.http.post(this.baseURL + 'data/sendConfirmation', obj, { headers: headers });
  }
  saveFromSheet(){
    this.loadToken();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', this.authToken);
    return this.http.get(this.baseURL + 'data/savingFromsheet', { headers: headers });
  }

  addNewAttendee(objj){
    this.loadToken();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', this.authToken);
    return this.http.post(this.baseURL + 'data/addNewAttendee',objj, { headers: headers });
  }
  addNewAP(){
    this.loadToken();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', this.authToken);
    return this.http.get(this.baseURL + 'data/addNewAccompanyPerson', { headers: headers });
  }

  updateAttDetails(objjj){
    this.loadToken();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', this.authToken);
    return this.http.post(this.baseURL + 'data/updateAttDetails',objjj, { headers: headers });
  }

  getAbstracts(){
    this.loadToken();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', this.authToken);
    return this.http.get(this.baseURL + 'data/getAbs', { headers: headers });
  }

  getParallelSessions(){
    this.loadToken();
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', this.authToken);
    return this.http.get(this.baseURL + 'data/getPS', { headers: headers });
  }

    deleteAttendee(bd){
      this.loadToken();
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', this.authToken);
      return this.http.post(this.baseURL + 'data/deleteAttendee', bd,{ headers: headers });
    }
 


}
